import React from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiFileText, FiClock } from "react-icons/fi";

const FullLoaderTramite = ({ visible, nombreTramite = "" }) => {
  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {visible && (
        <motion.div
          key="full-screen-loader-tramite"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[999999] flex flex-col items-center justify-center bg-slate-950/70 backdrop-blur-md select-none p-4"
          role="status"
          aria-live="polite"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="bg-white rounded-3xl shadow-2xl border border-slate-100 p-8 md:p-10 max-w-sm w-full flex flex-col items-center text-center relative overflow-hidden"
          >
            {/* Top gradient accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-primary via-primary_light to-primary" />

            {/* Animated Icon Container */}
            <div className="relative size-20 mb-5 flex items-center justify-center">
              {/* Outer pulsing wave */}
              <div className="absolute inset-0 rounded-2xl bg-primary/15 animate-ping opacity-30" />
              
              {/* Spinning border ring */}
              <div
                className="absolute inset-0 rounded-2xl border-2 border-primary/20 border-t-primary animate-spin"
                style={{ animationDuration: "1.8s" }}
              />

              {/* Center icon badge */}
              <div className="size-14 rounded-2xl bg-gradient-to-tr from-primary to-primary_light flex items-center justify-center text-white shadow-lg shadow-primary/25">
                <FiFileText className="size-7 animate-pulse" />
              </div>
            </div>

            {/* Sub-header badge */}
            <span className="text-[10px] font-black text-primary uppercase tracking-[0.2em] mb-1.5">
              IPEJAL Digital
            </span>

            {/* Main Title */}
            <h3 className="text-xl font-extrabold text-slate-900 tracking-tight mb-2">
              Validando Trámite
            </h3>

            {/* Optional Tramite Name or Generic Subtitle */}
            <p className="text-xs text-slate-500 font-medium leading-relaxed max-w-[270px]">
              {nombreTramite
                ? `Cargando detalles de ${nombreTramite}...`
                : "Sincronizando información y preparando tu expediente digital..."}
            </p>

            {/* Dynamic Animated Progress Bar */}
            <div className="w-full bg-slate-100 rounded-full h-2 mt-6 overflow-hidden relative">
              <motion.div
                initial={{ x: "-100%", width: "45%" }}
                animate={{ x: "250%" }}
                transition={{
                  repeat: Infinity,
                  duration: 1.4,
                  ease: "easeInOut"
                }}
                className="h-full bg-gradient-to-r from-primary to-primary_light rounded-full"
              />
            </div>

            {/* Footer status text */}
            <div className="flex items-center justify-between w-full mt-2.5 px-0.5">
              <span className="flex items-center gap-1 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">
                <FiClock className="size-3 text-primary animate-spin" style={{ animationDuration: "3s" }} />
                Verificando continuidad
              </span>
              <span className="text-[10px] font-bold text-primary font-mono">
                Consultando citas...
              </span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default FullLoaderTramite;
